import { FC } from 'react';
import { Avatar } from 'antd';
import { useMethods } from '@lhb/hook';
import V2Title from '@/common/components/Feedback/V2Title';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';
import V2Empty from '@/common/components/Data/V2Empty';
import { ReportData, Metric, Neighbor } from '../../types';
import styles from './index.module.less';

const positions = ['左3', '左2', '左1', '本点位', '右1', '右2', '右3'];
const PointSection: FC<{ data: ReportData }> = ({ data }) => {
  const methods = useMethods({
    field(item: Metric) {
      return <div key={item.label} className={item.label === '点位备注' ? styles.remark : styles.field}>
        <V2DetailItem label={item.label} value={item.value ?? '—'} type='textarea' textAreaRows={4} />
      </div>;
    },
    brand(item: Neighbor, index: number) {
      const tone = item.effect.includes('分流') ? 'diversion' : item.effect.includes('引流') ? 'attraction' : 'neutral';
      return <div key={`${item.position}-${item.name}-${index}`} className={`${styles.brand} ${styles[tone]}`}>
        <Avatar className={styles.brandLogo} size={24} src={item.logo} alt={`${item.name} Logo`}>logo</Avatar>
        <div className={styles.brandContent}>
          <strong className={styles.brandName} title={item.name}>{item.name}</strong>
          <div className={styles.brandMeta}><span>{item.position}</span><span className={styles.tag}>{item.effect || '关系待补充'}</span></div>
        </div>
      </div>;
    },
    opposite(item: Neighbor) { return item.position === '对面'; },
    position(position: string) {
      const brands = data.neighbors.filter(brand => brand.position === position);
      return position === '本点位' ? <div key={position} className={styles.current}><img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/chancepoint/svg/ownerBrand.svg`} alt='' width={20} height={20} /><span>本点位</span></div>
        : <div key={position} className={styles.position}>{brands.slice(0, 1).map(methods.brand)}</div>;
    },
  });
  return <section className={styles.root} aria-label='点位信息'>
    <V2Title type='H2' text='点位信息' bold innerStyle={{ fontSize: 18, fontWeight: 600, lineHeight: '24px', color: '#222' }} />
    <div className={styles.survey}>
      <V2Title type='H2' text='点位实勘填报' bold />
      <div className={styles.fields}>{data.survey.map(methods.field)}</div>
      <div className={styles.note}>※ 以上为拓店人员现场勘查填报内容，签约前需由拓展负责人复核确认。</div>
    </div>
    <div className={styles.neighbors}>
      <div className={styles.heading}>
        <V2Title type='H2' text='周边邻近品牌' bold />
        <div className={styles.legend}><span className={styles.attraction}>强引流（带来互补客流）</span><span className={styles.diversion}>分流（同类竞争/分类客流）</span><span className={styles.neutral}>中性</span></div>
      </div>
      <div className={styles.basis}>判定依据：模型综合品类重叠度、客群重叠度、价格带交叉、同商圈共存门店的历史客流互导数据，输出引流/分流/中性判定</div>
      {!data.neighbors.length ? <V2Empty customTip='暂无邻近品牌数据' /> : <div className={styles.diagramScroll}>
        <div className={styles.diagram}>
          <div className={styles.opposite}>{data.neighbors.filter(methods.opposite).slice(0, 1).map(methods.brand)}</div>
          <div className={styles.positions}>{positions.map(methods.position)}</div>
          <div className={styles.oppositeBottom}>{data.neighbors.filter(methods.opposite).slice(1, 2).map(methods.brand)}</div>
        </div>
      </div>}
    </div>
  </section>;
};
export default PointSection;
